<template>
    <span>
        <span ref="sizer" style="position:absolute; visibility:hidden;"></span>
        <fe-crud
            ref="crud"
            :autoload="false"
            :config="crudModel"
            @read="v => crudItems = v"
        />

        <fe-crud
            ref="listCrud"
            :autoload="false"
            :config="itemsModel"
            @read="v => items = v"
        />

        <fe-tooltip :tooltip="allSelected" :disabled="!showSelection">
            <v-autocomplete
                :placeholder="emptyText"
                :items="items"
                flat solo dense
                v-model="localValue"
                @input="updateItems"
                v-bind="elProps"
                :itemText="itemText"
                :itemValue="itemValue"
                return-object
                hide-details
                :style="selectStyle"
            >
                <template v-if="showSelection" v-slot:selection="{item,index}">
                    <template v-if="index===0">
                        <div :style="{ maxWidth: selectedTextWidth }" class="text-no-wrap text-truncate pr-2">
                            {{ selectedText }}
                        </div>
                        <span v-if="moreCount" class="text-smaller text-muted pl-1">[+{{moreCount}} more]</span>
                    </template>
                </template>
                <template v-else v-slot:selection="{ sel, index }">
                    <span  class="caption mr-1" v-if="index === 0">{{ totalSelections }} Selection{{totalSelections>1?'s':''}}</span>
                </template>
            </v-autocomplete>
        </fe-tooltip>
    </span>
</template>

<script>
    export default {
        name: 'CrudSelect',
        props: {
            itemsModel: {
            },
            itemsModelParams: {
                default: () => {}
            },
            itemValue: {
                type: String,
                default: 'id'
            },
            itemText: {
                type: String,
                default: 'name'
            },
            selectStyle: {
                type: String,
                default: ''
            },
            crudModel: {
                required: true
            },

            crudModelReadParams: {
                default: null
            },
            crudModelCreateParams: {
                default: () => {}
            },
            crudItemValue: {
                type: String,
                default: 'id'
            },
            lookupItemName: {
                type: String,
                default: 'name'
            },
            value: {
            },
            listItems: {
                default: () => []
            },
            showSelection: {
                type: Boolean,
                default: false
            },
        },
        computed: {
            elProps() {
                return { ...this.$attrs }
            },
            emptyText() {
                 let cnt = this.crudItems.length

                return cnt === 0 ? 'No Selection' : cnt + ' Selection'+(cnt>1?'s':'')
            },
            totalSelections() {
                if (!this.localValue) {
                    return 0
                } else if (Array.isArray(this.localValue)) {
                    return this.localValue.length
                } else if (this.localValue.hasOwnProperty) {
                    return Object.keys(this.localValue).length
                }

                return '??'
            },
            selectedText() {
                let sizer = this.$refs.sizer
                let maxw = this.$el.clientWidth
                let text = null
                this.moreCount = this.localValue && this.localValue.length
                for (let i in this.localValue) {
                    let itemText = ''
                    if (this.localValue[i] === Object(this.localValue[i])) {
                        itemText = this.localValue[i][this.itemText]
                    } else {
                        let rec = this.localItems.find(x => this.localValue[i] === x[this.itemValue])
                        itemText = rec[this.itemText] || this.localValue[i]
                    }

                    let tmp = [text, itemText].filter(Boolean).join(', ')
                    sizer.innerHTML = tmp + '...'
                    if (sizer.clientWidth > maxw && i > 0) {
                        break
                    }
                    this.moreCount--
                    text = tmp
                }

                return text
            },
            selectedTextWidth() {
                return this.$el ? this.$el.clientWidth + 'px' : '100%'
            },
        },
        watch: {    
            localValue(v) {
                this.allSelected = v.map(val => val.name).join(', ')
            }
        },
        data() {
            return {
                localValue: null,
                crudItems: [],
                items: [],
                moreCount: 0,
                allSelected: null,
            }
        },
        mounted() {
            this.loadCrudModel()
        },
        methods: {
            loadCrudModel() {
                // Load the list model
                this.$refs.listCrud.read(this.itemsModelParams)
                    .then(() => {
                        // Load the link table items
                        this.$refs.crud.read(this.crudModelReadParams)
                            .then((response) => {
                                this.setSelected()
                            })
                    })

            },
            setSelected() {
                let ids = []

                this.items.forEach((sch) => {
                    this.crudItems.forEach((sel) => {
                        if (sel[this.crudItemValue] === sch[this.itemValue]) {
                            ids.push(sch)
                        }
                    })
                })

                this.localValue = ids
            },
            updateItems() {
                let selections = this.localValue
                let existing   = this.crudItems

                let diff = this.$differenceByKey(existing, selections, this.crudItemValue, this.itemValue)

                if (diff.length === 0) {
                    return
                }

                if (existing.length < selections.length) {
                    // Adding
                    // adding records
                    let arr = []
                    diff.forEach(a => {
                        let o = Object.assign({}, this.crudModelCreateParams)
                        o[this.crudItemValue] = a.id
                        arr.push(o)
                    })


                    this.$setLoading(true)
                    this.$refs.crud.create(arr)
                        .finally(() => {
                            this.$setLoading(false)
                            this.loadCrudModel()
                        })
                } else {
                    // removing records
                    this.$setLoading(true)
                    this.$refs.crud.destroy(diff)
                        .finally(() => {
                            this.$setLoading(false)
                            this.loadCrudModel()
                        })
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
